import { Dialog } from '@/components/ui/dialog';
import { useOtpStore, useOtpStatus, useOtpSlotCount } from '@/store/otpStore';
import { OtpForm } from './OtpForm';

/**
 * Default OTP surface — a centered modal dialog. Mount once in the app
 * shell. Yields to any currently-mounted `<OtpSlot>`; when `slotCount > 0`
 * it does not render, so the inline slot wins.
 */
export function OtpModal() {
  const status = useOtpStatus();
  const slotCount = useOtpSlotCount();
  const cancelOtp = useOtpStore((s) => s.cancelOtp);

  const open = status === 'open' && slotCount === 0;

  return (
    <Dialog open={open} onClose={cancelOtp}>
      {open && <OtpForm variant="modal" />}
    </Dialog>
  );
}
